import Service from "../AuthService";

const Province = {
    getProvinces() {
        return Service.get(`provinces`);
    }
};

export default Province;
